import React, { Component, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";


import { View, Text, Image, TextInput, ActivityIndicator} from "react-native-web";

const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

class SearchBox extends Component {

  constructor(props) {

        super(props);



        let search_width;
        if (window.innerWidth > 1400)
        {
           search_width = 500;
        }
        else if (window.innerWidth > 1200)
        {
           search_width = 360;
        }
        else
        {
           search_width = 280;
        }




        this.state = {
          query: '',
          objects: [],
          search_width: search_width
        };

  }

  componentDidMount(){
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
  }


  UNSAFE_componentWillUnmount(){
     window.removeEventListener('resize', this.handleResize);
  }


  handleResize = () => {


        let search_width;
        if (window.innerWidth > 1400)
        {
           search_width = 500;
        }
        else if (window.innerWidth > 1200)
        {
           search_width = 360;
        }
        else
        {
           search_width = 280;
        }


        this.setState({
          search_width: search_width
        });

  }




  handleTextChange = (query) => {

        let realQuery = query;

        this.setState({query});

        var index = client.initIndex('Story');

        if (query === '')
        {
           query = '*';
        }

        index
        .search(query,
        {
          page: 0,
          filters: `specialtype:storrypage AND status:active`,
          hitsPerPage: 24
        })
        .then(({ hits, nbPages, page, nbHits }) =>
          {

                if (nbHits > 0)
                {
                    this.setState({
                      objects: hits
                    });

                    this.props.handleSearchChange(realQuery, hits);
                }
                else
                {
                    this.setState({
                      objects: []
                    });

                    this.props.handleSearchChange(realQuery, []);
                }


         });

  }


  clearSearch() {

         this.setState({
           query: ''
         });

        var index = client.initIndex('Story');

         index
         .search('*',
         {
           page: 0,
           filters: `specialtype:storrypage AND status:active`,
           hitsPerPage: 24
         })
         .then(({ hits, nbPages, page, nbHits }) =>
           {

                 if (nbHits > 0)
                 {
                   this.setState({
                     objects: hits
                   });

                   this.props.handleSearchChange('', hits);
                 }
                 else
                 {
                   this.setState({
                     objects: []
                   });

                   this.props.handleSearchChange('', []);
                 }


          });

   }



   get viewClearButton() {

         let _bool = false;

         if (this.state.query.length > 0)
         {
           _bool = true;
         }

         return _bool;

   }






  render() {




    return (

      <div style={{position: 'relative', width: this.state.search_width+'px', height: '50px', margin: 'auto', marginTop: '8px'}}>

          <Image source={{uri: '/img/search_icon_2.png'}} style={{position: 'absolute', zIndex: 1, left: 5, top: 8, width: 26, height: 26}}/>

         {this.viewClearButton &&
           <div onClick={this.clearSearch.bind(this)} style={{cursor: 'pointer', position: 'absolute', zIndex: 3, right: 5, height: 45}}>
               <View style={{width: 30, height: 45, justifyContent: 'center'}}><Image source={{uri: '/img/cancel_icon_grey.png'}} style={{width: 30, height: 30}}/></View>
           </div>
         }

          <TextInput style={{backgroundColor:'#f0f1f5', color: '#111', height: 44, width: this.state.search_width+'px', justifyContent: 'center',
                             paddingLeft: 40, paddingRight: 40, fontSize: 19, borderWidth: 1, borderColor: '#C8D1E2', borderRadius: 6,}} underlineColorAndroid='transparent'
                            onChangeText={this.handleTextChange} value={this.state.query} editable={true}
                            placeholder={i18n.t('Search')} placeholderTextColor="#777"
                               autoCapitalize="none" autoCorrect={false} autoComplete="off"/>
      </div>

    );

}


}


SearchBox.propTypes = {
};




export default SearchBox;
